import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Configuration Import (Must exist in src/config/brandConfig.js)
import { BRAND } from "./config/brandConfig";

// Component Imports (These files MUST be present in src/components/)
import Header from "./components/Header";
import SiteLayout from "./components/SiteLayout";

// Page Imports
import HomePage from "./pages/HomePage";
import ApproachPage from "./pages/ApproachPage";
import ServicesPage from "./pages/ServicesPage";
import ClientsPage from "./pages/ClientsPage";
import InsightsPage from "./pages/InsightsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";

/* =============== Internal Component: Footer Placeholder (Uses Design Tokens) =============== */
function FooterPlaceholder() {
  return (
    <footer
      style={{
        borderTop: `1px solid ${BRAND.colors.border}`,
        backgroundColor: BRAND.colors.card,
        marginTop: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: BRAND.layout.container.maxWidth,
          margin: "0 auto",
          padding: "1.25rem 1.5rem",
          fontSize: BRAND.type.Label.size,
          color: BRAND.colors.muted,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          gap: "0.75rem",
        }}
      >
        <div>
          © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <span>New England • Boston • Providence • Portsmouth</span>
        </div>
      </div>
    </footer>
  );
}

/* =============== Internal Component: NotFoundPage (Uses Design Tokens) =============== */
function NotFoundPage() {
  return (
    <div
      style={{
        padding: `${BRAND.layout.verticalPadding} ${BRAND.layout.container.paddingX}`,
        maxWidth: BRAND.layout.container.maxWidth,
        margin: "0 auto",
        width: "100%",
      }}
    >
      <h2
        style={{
          fontSize: BRAND.type.HeadingLG.size,
          fontWeight: 700,
          color: BRAND.colors.ink,
          marginBottom: "0.75rem",
        }}
      >
        Page not found
      </h2>
      <p style={{ fontSize: BRAND.type.Body.size, color: BRAND.colors.muted }}>
        The page you’re looking for doesn’t exist. Use the navigation above to
        return to the main sections of the site.
      </p>
    </div>
  );
}

/* =============== App (The Router) =============== */
function App() {
  return (
    <Router>
      {/* SiteLayout is assumed to be defined in SiteLayout.jsx and accepts children */}
      <SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/approach" element={<ApproachPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </SiteLayout>
    </Router>
  );
}

export default App;
